import React, { useState, useEffect } from 'react';
import { useSpring } from '@react-spring/web';

import { Container, Line, AnimatedLine, Circle } from './ProgressLine.styled';

export interface Props {
    sections?: HTMLDivElement[];
}

const ProgressLine: React.FC<Props> = props => {
    const { sections } = props;

    const [circlePositions, setCirclePositions] = useState<number[]>([]);
    const [sectionStartPositions, setSectionStartPositions] = useState<number[]>([]);
    const [sectionEndPositions, setSectionEndPositions] = useState<number[]>([]);
    const [activeHeight, setActiveHeight] = useState<number>(0);
    const [activeCircleIndex, setActiveCircleIndex] = useState<number>(-1);
    const [boundingTop, setBoundingTop] = useState<number>(0);

    const heightSpring = useSpring({
        height: `${activeHeight}px`,
        from: { height: '0px' },
        config: { mass: 1, tension: 100, friction: 70 }
    });

    useEffect(() => {
        if (sections) {
            let runningTotalHeight = 0;
            let previousTotalHeight = 0;
            const sectionStartPositions: number[] = [];
            const midPointPositions: number[] = [];
            const sectionEndPositions: number[] = [];

            sections.map(section => {
                const midPoint =
                    section.clientHeight / 2 +
                    Number(getComputedStyle(section).marginTop.replace('px', ''));

                previousTotalHeight = runningTotalHeight;
                runningTotalHeight +=
                    section.clientHeight +
                    Number(getComputedStyle(section).marginTop.replace('px', ''));

                const circlePosition = previousTotalHeight + midPoint;

                sectionStartPositions.push(previousTotalHeight);
                midPointPositions.push(circlePosition);
                sectionEndPositions.push(runningTotalHeight);
            });

            setSectionStartPositions(sectionStartPositions);
            setCirclePositions(midPointPositions);
            setSectionEndPositions(sectionEndPositions);
            setBoundingTop(window.scrollY + sections[0].getBoundingClientRect().top);
        }
    }, [sections]);

    useEffect(() => {
        function handleScroll() {
            if (sectionStartPositions.length > 0) {
                let finalPosition = 0;
                let finalIndex = -1;

                sectionStartPositions.map((position, index) => {
                    if (window.scrollY + window.innerHeight * 0.7 > position + boundingTop) {
                        finalPosition = sectionEndPositions[index];
                        finalIndex = index;
                    }
                });

                setActiveHeight(finalPosition);
                setActiveCircleIndex(finalIndex);
            }
        }

        handleScroll();

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [circlePositions]);

    return (
        <Container>
            <Line />
            <AnimatedLine style={heightSpring} />
            {circlePositions.length !== 0 &&
                circlePositions.map((position, index) => (
                    <Circle
                        key={index}
                        $active={index <= activeCircleIndex}
                        style={{ top: `${position}px` }}
                    />
                ))}
        </Container>
    );
};

export default ProgressLine;
